import api from '@/api/fetch'
import type { Config } from '@/types/config'

export function getConfig() {
  return api.get<Config>('/config').then(res => res.data)
}

export function sendUpdateHardwarePreferences(deviceId: string, config: any) {
  return api.put(`/devices/hardware-preferences/${deviceId}`, config)
}
